import React from 'react';
import { CardSeats } from './BridgeTypes';
import Hand from './Hand';
import Dealer from './Dealer';
import TableControls from './TableControls';
import './BridgeTable.css';

const BridgeTable: React.FC = () => {

    return (
        <div id='bridge-table-grid-container'>
            <div id='item-deal-table'>
                <Dealer />
            </div>
            <div id='item-seat-north'>
                <Hand seat={CardSeats.North} />
            </div>
            <div id='item-top-right-table' />
            <div id='item-seat-west'>
                <Hand seat={CardSeats.West} />
            </div>
            <div id='item-center-table'>
                <TableControls />
            </div>
            <div id='item-seat-east'>
                <Hand seat={CardSeats.East} />
            </div>
            <div id='item-bottom-left-table' />
            <div id='item-seat-south'>
                <Hand seat={CardSeats.South} />
            </div>
            <div id='item-bottom-right-table' />
        </div>
    );
};

export default BridgeTable;